import { LoopFilterTags, Protocol } from "@bridgesplit/abf-sdk";

import { FilterType, FilterConfig, PluralLabelText } from "../types";

export const EXPLORE_LOOPS_FILTER_DEFAULT = {
    DepositAssets: {
        enabled: false,
        condition: new Set<string>()
    },
    Tag: {
        enabled: false,
        condition: new Set<LoopFilterTags>()
    },
    IncludeNegativeApys: {
        enabled: true,
        condition: true
    },
    Protocols: {
        enabled: false,
        condition: new Set<Protocol>()
    },
    BorrowAssets: {
        enabled: false,
        condition: new Set<string>()
    },
    NewOnly: {
        enabled: false,
        condition: false
    }
};

export const EXPLORE_LOOPS_FILTER_CONFIG = {
    DepositAssets: FilterType.MultiSelect,
    BorrowAssets: FilterType.MultiSelect,
    Protocols: FilterType.MultiSelect,
    Tag: FilterType.MultiSelect,
    IncludeNegativeApys: FilterType.InclusiveBoolean,
    NewOnly: FilterType.Boolean
} satisfies FilterConfig;

export const DEPOSIT_ASSETS_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "All deposit assets",
        single: "deposit asset",
        multi: "deposit assets"
    },
    mobile: {
        all: "All"
    }
};

export const STRATEGIES_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "All strategies",
        single: "strategy",
        multi: "strategies"
    },
    mobile: {
        all: "All"
    }
};

export const ADDITIONAL_FILTERS_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "Filters",
        single: "filter",
        multi: "filters"
    },
    mobile: {
        all: "Additional filters"
    }
};

export const INCLUDE_NEGATIVE_APY_BUTTON_LABEL: PluralLabelText = {
    desktop: {
        all: "APYs",
        single: "APY",
        multi: "APYs"
    },
    mobile: {
        all: "APY filters"
    }
};
